<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <div slot="subtitulo">
      <span class="segunda-cor-fonte"> Filtros aplicados: </span>
      {{ textoSubtitulo }}
    </div>
    <div style="width: 360px">
      <CardDownload
        v-if="objetoArquivo.nomeArquivo"
        :nomeArquivo="objetoArquivo.nomeArquivo"
      />
      <div style="text-align: center" class="titulo negrito my-auto" v-else>
        NENHUM ARQUIVO ENCONTRADO
      </div>
      <unicom-botao
        @click="baixar"
        nomeIcone="download-cloud"
        :largura="360"
        style="margin-top: 72px"
      >
        BAIXAR
      </unicom-botao>
    </div>
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let objetoArquivo = {
      nomeArquivo: ""
    };

    return {
      loading: false,
      objetoArquivo
    };
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      this.inicializarArquivo();
    },
    inicializarArquivo() {
      this.loading = true;
      this.sleep(250).finally(() => {
        this.getArquivoListaPrestadores(this.filtroComputed)
          .then(res => {
            const { nomeArquivo } = res.data;

            this.objetoArquivo = { nomeArquivo };
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    baixar() {
      this.$store.commit("setLoadingModal", true);

      this.getDownloadListaPrestadores({
        codigoUnimed: this.filtroComputed.codigoUnimed
      })
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  },
  computed: {
    filtroComputed() {
      const { nomeUnimed, codigoUnimed } = this.objetoFiltro;

      return { nomeUnimed, codigoUnimed };
    },
    textoSubtitulo() {
      const { nomeUnimed, codigoUnimed } = this.objetoFiltro;
      console.log(this.objetoFiltro);
      if (!codigoUnimed) {
        return "Nenhum filtro aplicado";
      }

      return nomeUnimed;
    }
  }
};
</script>

<style lang="scss" scoped>
.container-vertical {
  display: flex;
  justify-content: center;
}
</style>
